module.exports = __webpack_public_path__ + "img/eliza1.87130cf0.png";